import { useState } from "react"
import { Button } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { useApi } from "../api"
import { AppHeader } from "../components/AppHeader"
import { ErrorResponseDialog } from "../components/ErrorResponseDialog"
import { ImageUploader } from "../components/ImageUploader"
import { SuccessDialog } from "../components/SuccessDialog"
import { ICargo } from "../interfaces"

export const AiNftMintPage = () => {
  const projectCode = 'SAI'
  const api = useApi(projectCode)
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [isLoading, setLoading] = useState(false)
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [image, setImage] = useState('')

  return (
    <>
      <div className="content colorbk" style={{ backgroundImage: `url('https://ai.supercoin.network/img/bgr.jpg')`, backgroundSize: "100% 100%" }}>
        <AppHeader title="NFT 鑄造"></AppHeader>
        <div className="p-4 p-sm-5">
          <ol className="text-white list-decimal">
            <li>每次鑄造需使用 10 顆燃料</li>
          </ol>
        </div>
      </div>
      <div className="bg-white p-3">
        <div className='p-9'>
          <ImageUploader projectCode={projectCode} onUploaded={(cargo: ICargo) => {
            if (cargo.returnCode === '000000') {
              setImage(cargo.info['file'])
            }
          }}></ImageUploader>
          <div className="text-center p-1 text-gray-500">請上傳NFT圖片</div>
        </div>
        <div className="p-3">
          <div className="text-gray-500">NFT名稱</div>
          <input className="border-1 p-2 rounded-md w-full" onChange={(e) => {
            setName(e.target.value)
          }} />
        </div>
        <div className="p-3">
          <div className="text-gray-500">NFT簡介</div>
          <textarea className="border-1 p-2 rounded-md w-full" rows={9} onChange={(e) => {
            setDescription(e.target.value)
          }}></textarea>
        </div>
        <ul className="nav nav-pills">
          <li className="nav-item w-100">
            <Button className="btn btn-success btn-block mt-4 w-100" disabled={isLoading} onClick={() => {
              setLoading(true)
              api.mintNftAssets(name, description, image, undefined , (cargo: ICargo) => {
                setLoading(false)
                if (cargo.returnCode === '000000') {
                  SuccessDialog({ title: t('mintSuccess') })
                } else {
                  ErrorResponseDialog(cargo, t)
                }
              })
            }}>{isLoading ? t('processing') : '開始鑄造 NFT'}</Button>
          </li>
          <li className="nav-item w-100">
            <div className="btn btn-success btn-block mt-4 w-100" onClick={() => {
              navigate(`/app/nft-pre-sale`)
            }}>我的 NFT</div>
          </li>
        </ul>
        <div className="m-86"></div>
      </div>
    </>

  )
}